export const DECODE_TOKEN = "DECODE_TOKEN";

export const GET_LOGGED_USER = "GET_LOGGED_USER";

export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
